<template>
    <div class="lb-card-media-content">
        
        <div v-if="audio" class="has-text-centered lb-media-link" >
            <p class="is-relative">
                <button
                    class="button is-link is-fullwidth"
                    @click.stop="openDetail"
                >
                    <span class="icon">
                        <i class="fas fa-play" />
                    </span>
                    <span>{{ $t('play_audio') }}</span>
                </button>
                <button
                    v-if="showControls"
                    class="lb-delete-media"
                    @click.stop="removeURL"
                >
                    <span class="icon is-small">
                        <i class="fas fa-trash" />
                    </span>
                </button>
            </p>
            <!--<vue-plyr ref="audio-plyr" class="is-block">
                <audio>
                    <source :src="audio | mediaSource" :type="audio.mimeType" />
                </audio>
            </vue-plyr>-->
            <!--<audio controls>
                    <source :src="audio | mediaSource" :type="audio.mimeType" />
                </audio>-->
               <!-- <video controls=""  name="media" controlsList="nodownload"><source :src="audio.url"></video>-->
            <button
                v-if="showControls"
                class="lb-delete-media"
                @click.stop="removeAudio"
            >
                <span class="icon is-small">
                    <i class="fas fa-trash" />
                </span>
            </button>
        </div>
        <div v-if="images && !showControls" @click.stop>
            <object-gallery :images="images" />
        </div>
        <div
            v-if="images && showControls"
            class="columns is-gapless is-marginless is-multiline is-centered"
            @click="$emit('click', 'image')"
        >
            <div
                v-for="(image, index) in images"
                :key="index"
                :class="{ 'is-half': images.length > 1 }"
                class="column"
                style="position: relative"
            >
                <figure class="image is-1by1">
                    <img
                        :src="image | mediaSource"
                        loading="lazy"
                        width="100"
                        style="object-fit: cover"
                    />
                </figure>
                <button
                    v-if="showControls"
                    class="lb-delete-media"
                    @click.stop="removeImage(index)"
                >
                    <span class="icon is-small">
                        <i class="fas fa-trash" />
                    </span>
                </button>
            </div>
        </div>
        <div v-if="!locationIsEmpty" @click="$emit('click', 'location')">
            <div class="is-relative">
                <figure class="image is-3by2">
                    <img
                        :src="staticMapURL"
                        loading="lazy"
                        style="object-fit: cover"
                    />
                </figure>
                <button
                    v-if="showControls"
                    class="lb-delete-media"
                    @click.stop="removeLocation"
                >
                    <span class="icon is-small">
                        <i class="fas fa-trash" />
                    </span>
                </button>
            </div>
        </div>
        <div v-if="video" @click.stop>
            <div class="is-relative">
                <vue-plyr :key="videoId">
                    <div class="plyr__video-embed">
                        <iframe
                            :src="`https://www.youtube.com/embed/${videoId}?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`"
                            allowfullscreen
                            allowtransparency
                            allow="autoplay"
                        />
                    </div>
                </vue-plyr>
                <button
                        v-if="showControls"
                        class="lb-delete-media"
                        @click="removeVideo()"
                    >
                        <span class="icon is-small">
                            <i class="fas fa-trash" />
                        </span>
                </button>
            </div>
        </div>
        <div v-for="(file, index) in files" :key="index" class="lb-media-link">
            <p class="control is-expanded">
                <a
                    :href="file.url"
                    target="_blank"
                    class="button is-link is-fullwidth is-inline-block overflow"
                >
                    <span class="icon">
                        <i :class="file.mimeType | iconForMime" class="fas" />
                    </span>
                    <span>{{ file.name }}</span>
                </a>
                <button
                    v-if="showControls"
                    class="lb-delete-media"
                    @click="removeFile(index)"
                >
                    <span class="icon is-small">
                        <i class="fas fa-trash" />
                    </span>
                </button>
            </p>
        </div>
        <div v-if="url" class="has-text-centered lb-media-link">
            <p class="is-relative">
                <a
                    :href="url"
                    target="_blank"
                    class="button is-link is-fullwidth"
                >
                    <span class="icon">
                        <i class="fas fa-link" />
                    </span>
                    <span>{{ $t('Object.url_more_info') }}</span>
                </a>
                <button
                    v-if="showControls"
                    class="lb-delete-media"
                    @click.stop="removeURL"
                >
                    <span class="icon is-small">
                        <i class="fas fa-trash" />
                    </span>
                </button>
            </p>
        </div>
        <div v-if="embed" class="is-relative">
            <div class="is-clipped" v-html="embed"></div>
            <button
                v-if="showControls"
                style="margin-top: 0.5rem"
                class="lb-delete-media"
                @click.stop="removeEmbed"
            >
                <span class="icon is-small">
                    <i class="fas fa-trash" />
                </span>
            </button>
        </div>
    </div>
</template>

<script>
import { staticMap } from '@/services/API';
import MediaCard from '@/components/MediaCard';
import ObjectGallery from '@/components/ObjectGallery';

import _ from 'underscore';
export default {
    components: { MediaCard, ObjectGallery },
    filters: {
        mediaSource(media) {
            if (typeof media === 'string') return media;
            if (typeof media === 'object') {
                if (_.isArray(media) && media.length) return media[0].url;
                else {
                    return media.url;
                    //return `https://img.labygram.com/upload/c_1/${media.url}`;
                }
            }
        },
        iconForMime(mime) {
            console.log('computing icon for', mime);
            if (mime.indexOf('pdf') > -1) {
                return 'fa-file-pdf';
            }
            if (mime.indexOf('image') > -1) {
                return 'fa-image';
            }
            if (mime.indexOf('audio') > -1) {
                return 'fa-file-audio';
            }

            return 'fa-file';
        },
    },
    props: {
        location: {
            type: Object,
            default() {
                return {};
            },
        },
        images: {
            type: [Array],
            default() {
                return [];
            },
        },
        files: {
            type: [Array],
            default() {
                return [];
            },
        },
        audio: { type: Object, default: undefined },
        url: { type: String, default: undefined },
        video: { type: String, default: undefined },
        showControls: { type: Boolean, default: false },
        embed: { type: String, default: undefined },
    },
    data() {
        return {
            videoInfo: { thumbnails: { high: {} } },
            urlInfo: undefined,
        };
    },
    computed: {
        videoId() {
            return this.$youtube.getIdFromUrl(this.video);
        },
        videoThumbnail() {
            return this.videoInfo.thumbnails.high;
        },
        staticMapURL() {
            return staticMap(
                this.location.longitude,
                this.location.latitude,
                this.location.zoomLevel
            );
        },
        locationIsEmpty() {
            return _.isEmpty(this.location);
        },
    },
    methods: {
        removeImage(position) {
            this.images.splice(position, 1);
            this.$emit('update:images', this.images);
        },
        removeFile(position) {
            this.files.splice(position, 1);
            this.$emit('update:files', this.files);
        },
        removeLocation() {
            this.$emit('update:location', undefined);
        },
        removeURL() {
            this.$emit('update:url', undefined);
        },
        removeEmbed() {
            this.$emit('update:embed', undefined);
        },
        removeAudio() {
            this.$emit('update:audio', undefined);
        },
        removeVideo() {
            this.$emit('update:video', undefined);
        },
        openDetail() {
            //console.log("go")
            this.$emit('openAudio')
        }
    },
};
</script>

<style lang="sass" scoped>
.lb-card-media-content
  display: flex
  flex-direction: column
  justify-content: flex-start

.lb-card-media-content > * + *
  padding-top: 0.5rem

.lb-card-media-content:last-child
  padding: 0

.overflow
  text-overflow: ellipsis
  white-space: nowrap
  overflow: hidden
</style>

<style lang="sass" scoped>
@import "src/assets/sass/slider"

::v-deep .agile
  &__nav-button
    width: 3.5rem
  .icon
    &:hover
      background-color: rgba(#000, .5)
      opacity: 1
      &:hover
        background: transparent
</style>
